import React, { useEffect, useRef, useState } from "react";
import "../Style/team.css";


import TeamMem from "../components/teammem";
import TeamValue from "../components/teamvalue";
import Teampic from "../components/teampic.";
import Howwework from "../components/Howwework";
import TeamBuild from "../components/teambuild";
import Teammatter from "../components/teammatter";
import AddressSection from "../components/AddSection";
import FormsSection from "../components/Forms";
import OurBlogs from "../components/Ourblogs";
import FooterSection from "../components/Footer";

function TeamPage() {
  const overlayRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (overlayRef.current) observer.observe(overlayRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="team-page">
        {/* CSS-only pattern layers, no images */}
        <div className="team-grid-pattern" aria-hidden="true" />
        <div className="team-blob team-blob-1" aria-hidden="true" />
        <div className="team-blob team-blob-2" aria-hidden="true" />
        <div className="team-blob team-blob-3" aria-hidden="true" />

        <div
          className={`team-overlay ${isVisible ? "team-visible" : ""}`}
          ref={overlayRef}
        >
          <div className="team-glass">
            {/* ONLY LOGO */}
            {/* <img
              src={mpeoplesLogo}
              alt="MPeoples Logo"
              className="team-logo team-anim team-anim-1"
            /> */}

            <span className="team-eyebrow team-anim team-anim-2">
              Careers at MPeoples
            </span>

            <h1 className="team-title team-anim team-anim-3">
              Life at MPeoples
            </h1>

            <p className="team-description team-anim team-anim-3">
              A culture driven by creativity, teamwork, and innovation—where ideas
              grow and people succeed.
            </p>
          </div>
        </div>
      </section>

      <TeamMem />
      <TeamValue />
      <Teampic />
      <Howwework />
      <TeamBuild />
      <Teammatter />
      <AddressSection />
      <FormsSection />
      <OurBlogs />
      <FooterSection />
    </>
  );
}

export default TeamPage;